import { FieldValues } from 'react-hook-form'
import { setContextualObject } from '@app-store'
import { store } from '../utils/agent.store'
import { NestedObject, RootObject } from '../types/layout.types'

const isLookupRef = (value: unknown): value is { id: number | string } =>
  value !== null &&
  typeof value === 'object' &&
  'id' in value &&
  (value as { id: unknown }).id !== '' &&
  (value as { id: unknown }).id != null

export const syncContextualLookupFields = (
  dispatch: typeof store.dispatch,
  formUniqueId: string,
  entityName: string,
  fields: Record<string, unknown>,
  existingContextual?: RootObject | null
): void => {
  if (!formUniqueId || !entityName) return

  const contextual =
    existingContextual ?? store.getState().contextual?.contextualObject ?? {}
  const formSlice: FieldValues = { ...(contextual[formUniqueId] || {}) }
  const entitySlice: NestedObject = {
    ...((formSlice[entityName] as NestedObject) || {}),
  }

  let hasUpdates = false

  for (const [fieldName, value] of Object.entries(fields)) {
    if (!isLookupRef(value)) continue

    entitySlice[fieldName] = {
      ...((entitySlice[fieldName] as NestedObject) || {}),
      id: value.id.toString(),
    }
    hasUpdates = true
  }

  if (!hasUpdates) return

  dispatch(
    setContextualObject({
      key: formUniqueId,
      value: {
        ...formSlice,
        [entityName]: entitySlice,
      },
    })
  )
}
